import { orchestrator } from 'satcheljs';
import {
    onDetailPaneOpened,
    onDetailPaneClosed,
    onMirrorFlowCompleted,
} from 'owa-personal-os-public-actions';
import { type StateChangeSource } from 'owa-left-pane-layout/lib/types/StateChangeSource';
import { getLastCollapsedFolderPaneStateChangeSource } from 'owa-left-pane-layout/lib/utils/folderPaneStateTracking';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import { shouldShowFolderPane } from '../selectors/shouldShowFolderPane';

/**
 * When the PersonalOS detail pane opens, collapse the folder pane to give
 * the detail content more horizontal space. Mirrors the Copilot Chat pattern
 * in copilotChatFolderPaneInterplayOrchestrators.ts.
 */
orchestrator(onDetailPaneOpened, () => {
    if (shouldShowFolderPane()) {
        setShowFolderPane(false, 12);
    }
});

/**
 * When the detail pane closes, restore the folder pane if we were the ones
 * who collapsed it (i.e. the user didn't manually collapse it in between).
 */
orchestrator(onDetailPaneClosed, () => {
    if (!shouldShowFolderPane() && getLastCollapsedFolderPaneStateChangeSource() === 12) {
        setShowFolderPane(true, 13);
    }
});

/**
 * When the user finishes the Mirror reveal flow (reaching the end or skipping),
 * restore the folder pane if the onramp card was the one that collapsed it to
 * launch the Mirror. The guards ensure we don't expand a pane the user manually
 * reopened, and that we only act when the onramp — not some other surface — did
 * the collapsing.
 */
orchestrator(onMirrorFlowCompleted, () => {
    if (!shouldShowFolderPane() && getLastCollapsedFolderPaneStateChangeSource() === 14) {
        setShowFolderPane(true, 16);
    }
});
